// TEMPORARY diagnostic — gated by ?realtime_test=1.
// Renders nothing without the URL flag. Subscribes to developments and shows
// a live event counter + the last 5 payloads. Deleted in Brief 03 Phase 7.

import React, { useCallback, useState } from 'react';
import { useRealtimeSubscription } from '../hooks/useRealtimeSubscription';

function isFlagEnabled() {
  if (typeof window === 'undefined') return false;
  try {
    return new URLSearchParams(window.location.search).get('realtime_test') === '1';
  } catch (_e) {
    return false;
  }
}

const STATUS_COLOR = {
  CONNECTING: 'var(--sandstone)',
  SUBSCRIBED: 'var(--success)',
  CHANNEL_ERROR: 'var(--danger)',
  TIMED_OUT: 'var(--danger)',
  CLOSED: 'var(--sandstone)',
};

export function RealtimeTestHarness() {
  const enabled = isFlagEnabled();
  const [eventCount, setEventCount] = useState(0);
  const [batchCount, setBatchCount] = useState(0);
  const [recent, setRecent] = useState([]);

  const handle = useCallback((events) => {
    setBatchCount(c => c + 1);
    setEventCount(c => c + events.length);
    setRecent(prev => {
      const formatted = events.map(e => ({
        time: new Date().toISOString().slice(11, 23),
        eventType: e.eventType,
        new_id: e.new?.id ?? null,
        old_id: e.old?.id ?? null,
      }));
      return [...formatted, ...prev].slice(0, 5);
    });
  }, []);

  const { status } = useRealtimeSubscription({
    table: 'developments',
    event: '*',
    onPayload: handle,
    enabled,
  });

  if (!enabled) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 16,
      right: 16,
      width: 340,
      maxHeight: 420,
      overflow: 'auto',
      background: 'var(--text)',
      color: '#f7f7f5',
      border:'var(--border-thin) solid var(--gold)',
      borderRadius:'var(--radius-md)',
      padding: 'var(--space-md)',
      fontFamily: 'monospace',
      fontSize: 'var(--text-xs)',
      lineHeight: 'var(--lh-normal)',
      zIndex: 99999, /* dev-only diagnostic — must outrank all production tokens; preserved literal per Discovery Section 5 */
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 'var(--space-sm)'}}>
        <span style={{ color: 'var(--gold)', fontWeight: 'var(--weight-bold)', letterSpacing: 1 }}>RT TEST · developments</span>
        <span style={{ color: STATUS_COLOR[status] || 'var(--sandstone)', fontWeight: 'var(--weight-bold)' }}>{status}</span>
      </div>
      <div style={{ color: 'var(--sandstone)', marginBottom: 'var(--space-md)'}}>
        events: <span style={{ color: '#f7f7f5' }}>{eventCount}</span>
        {' · '}
        batches: <span style={{ color: '#f7f7f5' }}>{batchCount}</span>
      </div>
      {recent.length === 0 ? (
        <div style={{ fontStyle: 'italic', color: 'var(--sandstone)' }}>waiting for events…</div>
      ) : (
        recent.map((e, i) => (
          <div key={i} style={{ marginBottom: 'var(--space-sm)', paddingBottom: 'var(--space-sm)', borderBottom:'var(--border-thin) solid #333' }}>
            <div>{e.time} · <strong style={{ color: 'var(--gold)' }}>{e.eventType}</strong></div>
            <div style={{ color: 'var(--sandstone)' }}>
              new.id={e.new_id || '—'}<br />
              old.id={e.old_id || '—'}
            </div>
          </div>
        ))
      )}
      <div style={{ marginTop: 'var(--space-sm)', fontSize: 'var(--text-2xs)', color: '#5a564f', textAlign: 'right' }}>
        Brief 03 · Phase 1 harness · removed in Phase 7
      </div>
    </div>
  );
}
